import type * as Types from '../../../__generated__/bffGlobalTypes';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type GetOrganizationVariables = Types.Exact<{ [key: string]: never; }>;


export type GetOrganization = {
  organization: {
    __typename?: 'Organization',
    identifier: string,
    slug: string,
    partnershipType: string
  } | null
};


export const GetOrganizationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOrganization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"identifier"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"partnershipType"}}]}}]}}]} as unknown as DocumentNode<GetOrganization, GetOrganizationVariables>;